import { useLocalStorage } from './use-local-storage';

const STORAGE_KEY = 'fomo-annotation-preferences';

type AnnotationPreferences = {
  showAnnotations: boolean;
  includeSeen: boolean;
};

const defaultPreferences: AnnotationPreferences = {
  showAnnotations: true,
  includeSeen: false,
};

export function useAnnotationPreferences() {
  const [prefs, setPrefs] = useLocalStorage<AnnotationPreferences>(STORAGE_KEY, defaultPreferences);

  const setShowAnnotations = (value: boolean) => setPrefs({ ...prefs, showAnnotations: value });
  const setIncludeSeen = (value: boolean) => setPrefs({ ...prefs, includeSeen: value });

  return {
    preferences: prefs,
    setShowAnnotations,
    setIncludeSeen,
  };
}
